import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { baseUrl } from '../../../constants';

@Injectable({ providedIn: 'root' })
export class DeliveryService {
  private baseUrl = `${baseUrl}DeliveryOrders`;

  constructor(private http: HttpClient) {}

  /** ✅ Attach Authorization header manually */
  private get headers() {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
      console.log('%c[DeliveryService] ✅ Token attached:', 'color: green', token);
    } else {
      console.warn('%c[DeliveryService] ⚠️ No token found in localStorage.', 'color: orange');
    }

    return { headers };
  }

  /** ✅ Get today's delivery orders */
  getToday(): Observable<any[]> {
    console.log('%c[DeliveryService] 📦 Fetching today’s delivery orders...', 'color: blue');
    return this.http.get<any[]>(`${this.baseUrl}/today`, this.headers).pipe(
      tap({
        next: (res) => console.log('%c[DeliveryService] ✅ Today’s orders loaded:', 'color: green', res),
        error: (err) => console.error('[DeliveryService] ❌ Failed to fetch today’s orders:', err)
      })
    );
  }

  getClients(search?: string): Observable<any[]> {
    let params = new HttpParams();
    if (search?.trim()) {
      params = params.set('search', search.trim());
    }
    return this.http.get<any[]>(`${this.baseUrl}/clients`, { params, ...this.headers });
  }

  getOrdersByContact(contactNumber: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/by-contact/${encodeURIComponent(contactNumber)}`, this.headers);
  }

  sendClientMessage(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/clients/message`, payload, this.headers);
  }

  /** ✅ Get filtered delivery orders */
  getFiltered(filter: any): Observable<{ items: any[]; total: number }> {
    let params = new HttpParams();
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value as string);
      }
    });

    console.log('%c[DeliveryService] 🔍 Applying filters:', 'color: dodgerblue', filter);
    console.log('%c[DeliveryService] 📡 Request params:', 'color: dodgerblue', params.toString());

    return this.http.get<{ items: any[]; total: number }>(
      `${this.baseUrl}/filter`,
      { params, ...this.headers }
    ).pipe(
      tap({
        next: (res) => console.log('%c[DeliveryService] ✅ Filtered results:', 'color: green', res),
        error: (err) => console.error('[DeliveryService] ❌ Filter request failed:', err)
      })
    );
  }

  /** ✅ Mark order as paid */
  markAsPaid(id: number, payload: any): Observable<any> {
    console.log(
      '%c[DeliveryService] 💰 Marking order as paid:',
      'color: purple',
      { id, payload }
    );

    return this.http.put(`${this.baseUrl}/${id}/mark-paid`, payload, this.headers).pipe(
      tap({
        next: (res) => console.log('%c[DeliveryService] ✅ Marked as paid successfully:', 'color: green', res),
        error: (err) => console.error('[DeliveryService] ❌ Mark-as-paid failed:', err)
      })
    );
  }
  create(payload: any): Observable<any> {
    console.log('%c[DeliveryService] 🆕 Creating new delivery order...', 'color: teal', payload);
    return this.http.post(`${this.baseUrl}`, payload, this.headers).pipe(
      tap({
        next: (res) => console.log('%c[DeliveryService] ✅ Created successfully:', 'color: green', res),
        error: (err) => console.error('[DeliveryService] ❌ Create failed:', err)
      })
    );
  }
  /** ✅ Cancel order */
  cancelOrder(id: number, payload: { remark: string }): Observable<any> {
    console.log('%c[DeliveryService] ❌ Cancelling order...', 'color: red', { id, payload });
    return this.http.post(`${this.baseUrl}/${id}/cancel`, payload, this.headers).pipe(
      tap({
        next: (res) => console.log('%c[DeliveryService] ✅ Cancelled successfully:', 'color: green', res),
        error: (err) => console.error('[DeliveryService] ❌ Cancel failed:', err)
      })
    );
  }

  
  
}
